import { useFormContext } from 'react-hook-form';
import { IPersonalDetailsFormData } from '../ui/sections';

export function useDetailsFormContext() {
	return useFormContext<IPersonalDetailsFormData>();
}
